// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCjqDSwnBNvmlSei9EH_kMHIm0ct-gmOxk",
  authDomain: "vocal-pad-472400-g5.firebaseapp.com",
  projectId: "vocal-pad-472400-g5",
  storageBucket: "vocal-pad-472400-g5.firebasestorage.app",
  messagingSenderId: "294784161620",
  appId: "1:294784161620:web:4214f941dcdbb3e3ef5ac1",
  measurementId: "G-ZBRR0Y4FJD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };